// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leaflet-container .leaflet-control-mouseposition {\n  background-color: rgba(255, 255, 255, 0.7);\n  box-shadow: 0 0 5px #bbb;\n  padding: 0 5px;\n  margin:0;\n  color: #333;\n  font: 11px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n}\n\n", ""]);
// Exports
module.exports = exports;
